import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const CacheContext = createContext(null);

function cacheFromStorage() {
  const o = {};
  try {
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k) o[k] = sessionStorage.getItem(k);
    }
  } catch (e) {}
  return o;
}

export function CacheProvider({ children }) {
  const [cache, setCache] = useState(cacheFromStorage);

  const setItem = useCallback((key, value) => {
    const s = value !== undefined && value !== null ? String(value) : "";
    setCache((prev) => ({ ...prev, [key]: s }));
    try {
      sessionStorage.setItem(key, s);
    } catch (e) {}
  }, []);

  const getItem = useCallback((key) => {
    if (cache[key] !== undefined) return cache[key];
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }, [cache]);

  const clearAll = useCallback(() => {
    setCache({});
    try {
      sessionStorage.clear();
    } catch (e) {}
  }, []);

  const clearItem = useCallback((key) => {
    setCache((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }, []);

  const value = useMemo(
    () => ({ getItem, setItem, clearAll, clearItem, cache }),
    [getItem, setItem, clearAll, clearItem, cache]
  );

  return <CacheContext.Provider value={value}>{children}</CacheContext.Provider>;
}

export function useCache() {
  const ctx = useContext(CacheContext);
  if (!ctx) throw new Error("useCache must be used within CacheProvider");
  return ctx;
}

export default CacheContext;
